export const EVENTS_EN = {
    'event.named': '{what}: {doing}',
    'activity.event.automation.schedule': 'A scheduled time',
    'event.verb.changed': 'changed',
    'event.verb.created': 'created',
    'event.verb.approved': 'approved',
    'event.verb.recorded': 'recorded',
    'event.verb.decided': 'decided',
    'event.verb.issued': 'issued',
    'event.verb.completed': 'completed',
    'event.verb.closed': 'closed',
    'event.verb.withdrawn': 'withdrawn',
    'event.verb.assigned': 'assigned',
    'event.verb.published': 'published',
    'event.verb.overdue': 'overdue',
    'event.verb.ended': 'ended',
    'event.verb.opened': 'opened',
    'event.verb.cancelled': 'cancelled',
    'event.verb.activated': 'activated',
    'event.verb.requested': 'requested',
    'event.verb.status_changed': 'status changed',
    'event.verb.signed': 'signed',
    'event.verb.submitted': 'submitted',
    'event.verb.posted': 'posted',
    'event.verb.updated': 'updated',
    'event.verb.paid': 'paid',
    'event.verb.confirmed': 'confirmed',
    'event.verb.rejected': 'rejected',
    'event.verb.acknowledged': 'acknowledged',
    'event.verb.received': 'received',
    'event.verb.lost': 'lost',
    'event.verb.suspended': 'suspended',
    'event.verb.returned': 'returned',
    'event.verb.scheduled': 'scheduled',
    'event.verb.matched': 'matched',
    'event.verb.accepted': 'accepted',
    'event.verb.attached': 'attached',
    'event.verb.proposed': 'proposed',
    'event.verb.generated': 'generated',
    'event.verb.renewed': 'renewed',
    'event.verb.stage_changed': 'stage changed',
    'event.verb.reopened': 'reopened',
    'event.verb.reminded': 'reminded',
    'event.verb.locked': 'locked',
    'event.verb.threshold_reached': 'threshold reached',
    'event.verb.due': 'due',
    'event.verb.failed': 'failed',
    'event.verb.imported': 'imported',
    'event.verb.reported': 'reported',
    'event.verb.started': 'started',
    'event.verb.allocated': 'allocated',
    'event.verb.added': 'added',
    'event.verb.reversed': 'reversed',
    'event.verb.invoiced': 'invoiced',
    'event.verb.sent': 'sent',
    'event.verb.stopped': 'stopped',
    'event.verb.deposited': 'deposited',
    'event.verb.terminated': 'terminated',
    'event.verb.qualified': 'qualified',
    'event.verb.replied': 'replied',
    'event.verb.retired': 'retired',
    'event.verb.restored': 'restored',
    'event.verb.superseded': 'superseded',
    'event.verb.expiring': 'expiring soon',
    'event.verb.expired': 'expired',
    'event.verb.escalated': 'escalated',
    'event.verb.queued': 'queued',
    'event.verb.linked': 'linked',
    'event.verb.unanswered': 'unanswered',
    'event.verb.won': 'won',
    'event.verb.resumed': 'resumed',
    'event.verb.moved': 'moved',
    'event.verb.uploaded': 'uploaded',
    'event.verb.registered': 'registered',
    'event.verb.revoked': 'revoked',
    'event.verb.invited': 'invited',
    'event.verb.resolved': 'resolved',
    'event.verb.filed': 'filed',
    'event.verb.converted': 'converted',
    'event.verb.launched': 'launched',
    'event.verb.joined': 'joined',
    'event.verb.removed': 'removed',
    'event.verb.renamed': 'renamed',
    'event.verb.enabled': 'enabled',
    'event.verb.merged': 'merged',
    'event.verb.archived': 'archived',
    'event.verb.granted': 'granted',
    'event.verb.delivered': 'delivered',
    'event.verb.deleted': 'deleted',
    'event.verb.duplicated': 'duplicated',
    'event.verb.drafted': 'drafted',
    'event.verb.edited': 'edited',
    'event.verb.adjusted': 'adjusted',
    'event.verb.hired': 'hired',
    'event.verb.rated': 'rated',
    'event.verb.assessed': 'assessed',
    'event.verb.fulfilled': 'fulfilled',
    'event.verb.detected': 'detected',
    'event.verb.cleared': 'cleared',
    'event.verb.credited': 'credited',
    'event.verb.declined': 'declined',
    'event.verb.dispatched': 'dispatched',
    'event.verb.executed': 'executed',
    'event.verb.computed': 'computed',
    'event.verb.notified': 'notified',
    'event.verb.reserved': 'reserved',
    'event.verb.applied': 'applied',
    'event.verb.voided': 'voided',
    'event.verb.synced': 'synced',
    'event.verb.captured': 'captured',
    'event.verb.lifted': 'lifted',
    'event.verb.ready': 'ready',
    'event.verb.done': 'done',
    'event.verb.warning': 'warning',
};
export const EVENTS_AR = {
    'event.named': '{what}: {doing}',
    'activity.event.automation.schedule': 'موعد مجدول',
    'event.verb.changed': 'تعديل',
    'event.verb.created': 'إنشاء',
    'event.verb.approved': 'اعتماد',
    'event.verb.recorded': 'تسجيل',
    'event.verb.decided': 'البتّ',
    'event.verb.issued': 'إصدار',
    'event.verb.completed': 'إكمال',
    'event.verb.closed': 'إغلاق',
    'event.verb.withdrawn': 'سحب',
    'event.verb.assigned': 'إسناد',
    'event.verb.published': 'نشر',
    'event.verb.overdue': 'تأخّر',
    'event.verb.ended': 'انتهاء',
    'event.verb.opened': 'فتح',
    'event.verb.cancelled': 'إلغاء',
    'event.verb.activated': 'تفعيل',
    'event.verb.requested': 'طلب',
    'event.verb.status_changed': 'تغيّر الحالة',
    'event.verb.signed': 'توقيع',
    'event.verb.submitted': 'تقديم',
    'event.verb.posted': 'ترحيل',
    'event.verb.updated': 'تحديث',
    'event.verb.paid': 'سداد',
    'event.verb.confirmed': 'تأكيد',
    'event.verb.rejected': 'رفض',
    'event.verb.acknowledged': 'تأكيد الاطلاع',
    'event.verb.received': 'استلام',
    'event.verb.lost': 'خسارة',
    'event.verb.suspended': 'إيقاف مؤقت',
    'event.verb.returned': 'إرجاع',
    'event.verb.scheduled': 'جدولة',
    'event.verb.matched': 'مطابقة',
    'event.verb.accepted': 'قبول',
    'event.verb.attached': 'إرفاق',
    'event.verb.proposed': 'اقتراح',
    'event.verb.generated': 'توليد',
    'event.verb.renewed': 'تجديد',
    'event.verb.stage_changed': 'تغيّر المرحلة',
    'event.verb.reopened': 'إعادة فتح',
    'event.verb.reminded': 'تذكير',
    'event.verb.locked': 'قفل',
    'event.verb.threshold_reached': 'بلوغ الحد',
    'event.verb.due': 'استحقاق',
    'event.verb.failed': 'إخفاق',
    'event.verb.imported': 'استيراد',
    'event.verb.reported': 'إبلاغ',
    'event.verb.started': 'بدء',
    'event.verb.allocated': 'تخصيص',
    'event.verb.added': 'إضافة',
    'event.verb.reversed': 'عكس',
    'event.verb.invoiced': 'فوترة',
    'event.verb.sent': 'إرسال',
    'event.verb.stopped': 'إيقاف',
    'event.verb.deposited': 'إيداع',
    'event.verb.terminated': 'إنهاء',
    'event.verb.qualified': 'تأهيل',
    'event.verb.replied': 'ردّ',
    'event.verb.retired': 'إيقاف الاستخدام',
    'event.verb.restored': 'استعادة',
    'event.verb.superseded': 'استبدال',
    'event.verb.expiring': 'قرب الانتهاء',
    'event.verb.expired': 'انتهاء الصلاحية',
    'event.verb.escalated': 'تصعيد',
    'event.verb.queued': 'وضع في الانتظار',
    'event.verb.linked': 'ربط',
    'event.verb.unanswered': 'بلا ردّ',
    'event.verb.won': 'فوز',
    'event.verb.resumed': 'استئناف',
    'event.verb.moved': 'نقل',
    'event.verb.uploaded': 'رفع',
    'event.verb.registered': 'تسجيل',
    'event.verb.revoked': 'إبطال',
    'event.verb.invited': 'دعوة',
    'event.verb.resolved': 'حلّ',
    'event.verb.filed': 'قيد',
    'event.verb.converted': 'تحويل',
    'event.verb.launched': 'إطلاق',
    'event.verb.joined': 'انضمام',
    'event.verb.removed': 'إزالة',
    'event.verb.renamed': 'إعادة تسمية',
    'event.verb.enabled': 'تفعيل',
    'event.verb.merged': 'دمج',
    'event.verb.archived': 'أرشفة',
    'event.verb.granted': 'منح',
    'event.verb.delivered': 'تسليم',
    'event.verb.deleted': 'حذف',
    'event.verb.duplicated': 'نسخ',
    'event.verb.drafted': 'صياغة',
    'event.verb.edited': 'تحرير',
    'event.verb.adjusted': 'تسوية',
    'event.verb.hired': 'تعيين',
    'event.verb.rated': 'تقييم',
    'event.verb.assessed': 'تقدير',
    'event.verb.fulfilled': 'تنفيذ',
    'event.verb.detected': 'رصد',
    'event.verb.cleared': 'تصفية',
    'event.verb.credited': 'قيد دائن',
    'event.verb.declined': 'اعتذار',
    'event.verb.dispatched': 'إرسال',
    'event.verb.executed': 'تنفيذ',
    'event.verb.computed': 'احتساب',
    'event.verb.notified': 'إشعار',
    'event.verb.reserved': 'حجز',
    'event.verb.applied': 'تطبيق',
    'event.verb.voided': 'إبطال',
    'event.verb.synced': 'مزامنة',
    'event.verb.captured': 'التقاط',
    'event.verb.lifted': 'رفع',
    'event.verb.ready': 'جاهزية',
    'event.verb.done': 'إنجاز',
    'event.verb.warning': 'تنبيه',
};
//# sourceMappingURL=i18n-events.js.map